import React from 'react';
import PropTypes from 'prop-types';
import './AuthButton.css';

/**
 * Primary call-to-action button for authentication forms.
 *
 * Full-width button with consistent styling used for form submission
 * actions like "Log In" and "Sign Up". Supports loading states and
 * disabled styling for form validation.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Button label content
 * @param {string} [props.type='submit'] - HTML button type attribute
 * @param {boolean} [props.disabled=false] - Whether button is disabled
 * @param {function} [props.onClick] - Click event handler
 * @param {string} [props.className=''] - Additional CSS classes
 * @returns {JSX.Element}
 */
function AuthButton({
  children,
  type = 'submit',
  disabled = false,
  onClick,
  className = '',
  ...rest
}) {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`auth-btn ${className}`.trim()}
      {...rest}
    >
      {children}
    </button>
  );
}

AuthButton.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default AuthButton;
